var _defs, _rect, _image, _image2, _path, _path2, _image3, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _polygon, _path24, _path25, _path26, _path27, _path28, _polygon2, _path29, _path30, _circle, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _rect3, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _polygon3, _path77, _path78, _path79, _path80, _path81, _polygon4, _path82, _path83, _circle2, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg12D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160.59 229.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#f16148;}.cls-3{fill:#bc141a;}.cls-4{fill:#fde4e0;}.cls-5{fill:#bd6956;}.cls-6{fill:#8d321d;}.cls-7{fill:#cc1217;}.cls-8{fill:#fbd0d4;}.cls-9{fill:#fde9f1;}.cls-10{fill:#fbd9e7;}.cls-11{fill:url(#linear-gradient);}.cls-12{fill:url(#linear-gradient-2);}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:url(#linear-gradient-6);}.cls-17{fill:url(#linear-gradient-7);}.cls-18{fill:url(#linear-gradient-8);}.cls-19{fill:#6fbe44;}.cls-20{fill:#be8a2c;}.cls-21{fill:url(#linear-gradient-9);}.cls-22{fill:url(#linear-gradient-10);}.cls-23{fill:url(#linear-gradient-11);}.cls-24{fill:url(#linear-gradient-12);}.cls-25{fill:url(#linear-gradient-13);}.cls-26{fill:url(#linear-gradient-14);}.cls-27{fill:#515254;}.cls-28{fill:#ffcb05;}.cls-29{fill:#4a4b4c;}.cls-30{fill:url(#linear-gradient-15);}.cls-31{fill:url(#linear-gradient-16);}.cls-32{fill:url(#linear-gradient-17);}.cls-33{fill:url(#linear-gradient-18);}.cls-34{fill:url(#linear-gradient-19);}.cls-35{fill:url(#linear-gradient-20);}.cls-36{fill:url(#linear-gradient-21);}.cls-37{fill:url(#linear-gradient-22);}.cls-38{fill:url(#linear-gradient-23);}.cls-39{fill:url(#linear-gradient-24);}.cls-40{fill:url(#linear-gradient-25);}.cls-41{fill:url(#linear-gradient-26);}.cls-42{fill:url(#linear-gradient-27);}.cls-43{fill:url(#linear-gradient-28);}.cls-44{fill:url(#linear-gradient-29);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 66.31,
    y1: 24.31,
    x2: 87.9,
    y2: 24.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec61b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 74.48,
    y1: 79.81,
    x2: 99.65,
    y2: 79.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 89.9,
    y1: 95.27,
    x2: 112.92,
    y2: 95.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 53.15,
    y1: 101.89,
    x2: 65.98,
    y2: 101.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 66.94,
    y1: 40.38,
    x2: 91.31,
    y2: 40.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 66.31,
    y1: 24.43,
    x2: 84.23,
    y2: 24.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 66.48,
    y1: 24.06,
    x2: 68.4,
    y2: 24.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 82.5,
    y1: 52.85,
    x2: 90.35,
    y2: 52.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 110.07,
    y1: 70.83,
    x2: 92.74,
    y2: 110.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 109.2,
    y1: 70.45,
    x2: 91.87,
    y2: 110.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 108.8,
    y1: 70.28,
    x2: 91.47,
    y2: 110.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 108.93,
    y1: 70.33,
    x2: 91.59,
    y2: 110.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 109.69,
    y1: 70.66,
    x2: 92.35,
    y2: 110.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 111.27,
    y1: 71.35,
    x2: 93.93,
    y2: 111.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 36.38,
    y1: 182.45,
    x2: 93.02,
    y2: 182.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67686b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3d5d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -2139.33,
    y1: 777.37,
    x2: -2117.75,
    y2: 777.37,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -2131.16,
    y1: 832.87,
    x2: -2106,
    y2: 832.87,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -2115.75,
    y1: 848.33,
    x2: -2092.72,
    y2: 848.33,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -2152.5,
    y1: 854.96,
    x2: -2139.66,
    y2: 854.96,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -2138.7,
    y1: 793.45,
    x2: -2114.34,
    y2: 793.45,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -2139.33,
    y1: 777.5,
    x2: -2121.41,
    y2: 777.5,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -2139.16,
    y1: 777.12,
    x2: -2137.25,
    y2: 777.12,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -2123.15,
    y1: 805.91,
    x2: -2115.3,
    y2: 805.91,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -2095.57,
    y1: 823.89,
    x2: -2112.91,
    y2: 863.72,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -2096.45,
    y1: 823.51,
    x2: -2113.78,
    y2: 863.34,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -2096.84,
    y1: 823.34,
    x2: -2114.17,
    y2: 863.18,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -2096.72,
    y1: 823.39,
    x2: -2114.05,
    y2: 863.23,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -2095.96,
    y1: 823.72,
    x2: -2113.29,
    y2: 863.56,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -2094.38,
    y1: 824.41,
    x2: -2111.71,
    y2: 864.25,
    gradientTransform: "translate(-2048.09 985.89) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1741.23,
    y: -51.82,
    width: 2406.31,
    height: 1210.9
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 153,
    height: 217,
    transform: "translate(2.23 8.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAADZCAYAAAAzBJLWAAAACXBIWXMAAAsSAAALEgHS3X78AAACc0lEQVR4Xu3WMW7DMBQFwU8h978yU9lJZBiGHW03UwmiysWj1t57Th5ewAfW7eE4HQiMq9xb+h2ZwLjanvmJTGBkztclXG2LjJzIyB3jf4yYJSMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycyciIjJzJyIiMnMnIiIycycsfMrFcfwX9YMnIio7ZukbkyyVgySmvmb2TWjCvde/p6djAze+B9D2P1Db/WDbEXV0TbAAAAAElFTkSuQmCC"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 17,
    transform: "translate(13.23 47.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAARCAYAAAAG/yacAAAACXBIWXMAAAsSAAALEgHS3X78AAABl0lEQVQoU3WSS2/TQBSFv/ErHjt2I0JoEIEiVSxYsGFDF/n5QbBlh9gQlVQKVErbmCT2xDOXRRrTvM5u7r1nzn0cJSIcw6g/EIDhdKL2c95h+WPCP5k6TvoyuJD8PAf+Kz5FsB8Y9QfSu+zRSlq42jH/M98v2VX6/PK16FzjKQUK0m4KbJRPkkSE6m9FfKaJdIjOY7LnGba2O202pG2w8+qMKInQuQYUWa9N+1FxW6NEpHmcv3uB53tkvYwwDgGwa8tqXlLcFsx+zQAIRv2BRDqie9El1CFJR+P5Hl7gA5uO/NBDKYizmLIo8YbTiTIrQ1mUVIsKayx2bVEKxG3HUKTPUvzQJ4iCzUzD6UTd3dxRVzW2togIzjoQcNbhrOPh9xyzNFxdj9XOnRazBUHkk3QSlKewxlIWJc4K69WaT+OfqlnEFl/fvBWdx6TdNjqLMaWhKiqWDys+fv/ReHDnTlfXY2WWBmcd1lqApq2nUMdc/u3DewlaAfc394jIgdMPvAdQ3BZESXSUACdcPpxOlFkagujon/wDwBi9xgVwUNcAAAAASUVORK5CYII="
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.05,48.16V56H14.21A46.37,46.37,0,0,0,20.05,48.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.06,64.07v-8H25.9A47.14,47.14,0,0,0,20.06,64.07Z"
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 17,
    transform: "translate(132.23 169.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAARCAYAAAAG/yacAAAACXBIWXMAAAsSAAALEgHS3X78AAABnklEQVQoU3WS3WsTURDFf/fu3U/TRNIiqU1iKyJC3/oiaP/8NKAg+Fh8UWPEoCa2yXZ3k7u740PcbdOuBy4XzpnDDGcGEaHpjXp9+Z+macD4aCiVsUk3TaRSiv1n++TrvEl+2Gn8dChFXgBQFiUfXr540E2J3HLjo6F0B138lo/jajaJpbA5868L3nyfqKpuZzwv8kCEsB1gPIMbWLJVxt6Tvbtlt+N9PH0lfssnaAe1aHyXsBNiPMP7k+f1SBpg1OuLdhSt7iOM7+IGLsY3OI5GOxrjG7zI4+JwIABm1OtL9DjCDbbFYTtAOxqlFUortKMJ2+GWU3BxOBANkFwlxIsbANJlRpVeHdK/P57fbJd7PpsqgHW8ZjH9g80sCJR5SWELyrwkXabMLmeICOezqaojf3d8IjazHBwfEHYCglbAJrPEv2MWk0VtqIMAeP3lswKYT+ZsEgsK4l8rslUGUBt2TJUgpbD8ueR6tsR4hk264T4aby+9TvEij8JuA3n741vdBe6dUYVRry9KKcJOyNnlpx0DNBzsXSRXSSP/F2sf2GKdHSKTAAAAAElFTkSuQmCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.77,186.4v-7.88h5.85A46.22,46.22,0,0,0,138.77,186.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.77,170.49v8h-5.85A47.56,47.56,0,0,0,138.77,170.49Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23,41.14a12.74,12.74,0,0,0,3.56,4.18,8.63,8.63,0,0,0,4.34,1.53v.52a17.73,17.73,0,0,1-4.76-.9,20.72,20.72,0,0,1-4.79-2.25,23.35,23.35,0,0,1-3.91-3.08,15.31,15.31,0,0,1-3.68-2,10.76,10.76,0,0,1-3.06-3.85,12.46,12.46,0,0,1-1.09-5.39,11.14,11.14,0,0,1,3.18-8.14,10.35,10.35,0,0,1,7.69-3.25,10,10,0,0,1,7.43,3.25A11.34,11.34,0,0,1,31,30,11.56,11.56,0,0,1,28.79,37,11,11,0,0,1,23,41.14ZM20.27,19.78a5.91,5.91,0,0,0-4.72,2.09q-2.27,2.64-2.26,8.05c0,3.54.76,6.26,2.29,8.18a5.71,5.71,0,0,0,4.69,2.21,6.09,6.09,0,0,0,4.89-2.21q2.18-2.62,2.17-7.71a16.13,16.13,0,0,0-1.19-6.6,6.76,6.76,0,0,0-2.44-3A6.24,6.24,0,0,0,20.27,19.78Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.25,192.24a12.8,12.8,0,0,0-3.56-4.17,8.55,8.55,0,0,0-4.34-1.54V186a17.69,17.69,0,0,1,4.76.89,21.17,21.17,0,0,1,4.79,2.26,23.32,23.32,0,0,1,3.91,3.07,15.66,15.66,0,0,1,3.68,2,10.82,10.82,0,0,1,3.06,3.84,12.5,12.5,0,0,1,1.09,5.4,11.16,11.16,0,0,1-3.18,8.14,10.37,10.37,0,0,1-7.69,3.24,10,10,0,0,1-7.43-3.25,11.33,11.33,0,0,1-3.14-8.2,11.6,11.6,0,0,1,2.24-7.05A11,11,0,0,1,135.25,192.24ZM138,213.61a5.88,5.88,0,0,0,4.72-2.1q2.26-2.62,2.26-8t-2.29-8.18a5.71,5.71,0,0,0-4.69-2.21,6.09,6.09,0,0,0-4.89,2.21q-2.17,2.61-2.17,7.71a16.16,16.16,0,0,0,1.19,6.6,6.73,6.73,0,0,0,2.44,3A6.24,6.24,0,0,0,138,213.61Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.32,106.84l9.2-11.49L47,93.17a15.37,15.37,0,0,1-3.77-4.41c-.35-.68-2.32.07-.61,3L44,94.59l-6.45-5.31s-3.54-3.2-3.7-1.72c-.09.93,1.3,2.86,1.89,3.25s4.88,5.45,4.88,5.45l-5.24-3.94s-3.88-3.18-4.21-2.66c-1.26,2,1.3,3.77,2,4.21s5.79,5,5.79,5L32.08,95s-2.63-1.89-2.81-1.17c-.46,1.76,1.39,3,1.77,3.21.69.4,5.81,3.8,5.81,3.8l-1.8-.24s-5.3-1.92-5.34-1.46c-.19,2.3,9.32,6.27,9.32,6.27A20.79,20.79,0,0,0,41.32,106.84Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.31,61.56l.09,15.33s8.75.25,10-4.75S73.31,61.56,73.31,61.56Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 76.65,
    y: 63.14,
    width: 7.5,
    height: 18.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M67.54,36.68s-6.78-7.18,0-8.78c0,0-1.59-5.18,8.38-6.78s48.25-8,45.06,59.42L93.47,77.35,82.7,54.22Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.31,75.56S89.08,63.39,89.48,50.24,82.3,22.32,67.94,31.09l-.63,7.47-3,10,3,1.33-.23,3.62.8,1.59-.6,1.6a11.67,11.67,0,0,1,1,1.39c.24.45-2,6.3,1.7,6.3,5.11,0,9.67-.17,10.29,2.71,1,4.4,2.28,7-1,7.79-13,3-14.33,3-14.33,3s-8.2,28.58,22.5,30.57,35.89-27.52,35.89-27.52Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.89,41.46a4.13,4.13,0,0,0,2.49-.05c1.88-.6,4.1-1.94,5.6.23l-1.25-.42a3.42,3.42,0,0,0-2.28.84s.22,1.95-1.35,1.87a1.2,1.2,0,0,1-1.19-1.57S70.19,42.66,69.89,41.46Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.66,36.45s.15,1.42.6,1.42,5.91-3.21,9.35,1.05c0,0-2.17-5-8.68-2.09A.85.85,0,0,1,69.66,36.45Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M123.05,78.29l-10.13-1.88C108,84.81,98.26,97,84.4,94.38c-14.74-2.8-18.25-11.93-19.05-17A9,9,0,0,0,62,78.56c-6.87,7-32.95,43.56-32.95,43.56l99.6-11.35V85.42C128.67,78.82,123.05,78.29,123.05,78.29Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M79,49.56a4.67,4.67,0,1,1-4.67-4.67A4.66,4.66,0,0,1,79,49.56Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.06,40.89s-.33-1.5,2.09-1.75S71.56,39.22,71.06,40.89Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.28,56.7l.6-1.6,2.35.08A4.1,4.1,0,0,1,67.28,56.7Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M67.08,53.51a4.5,4.5,0,0,0,.53-.24s2.08.8,2.62,1.91l-2.35-.08Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68.4,27.64s7.5-5.5,15.75-2,14.25,7.25,15,32.5c0,0-.14,13.94,11.18,19a24.88,24.88,0,0,1-8.93-18.47c-.25-12,.25-30.5-17.25-35S67.54,27.9,67.54,27.9Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M66.31,17.89,67,28.08s7.7-3.47,14.23-2.27a25.77,25.77,0,0,1,6.67,4.91s-3.24-10.24-10.58-10S68.76,20.28,66.31,17.89Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121,78.22s-9.33-4.33-8-16.33-2.67-29.67-7.67-32C105.31,29.89,118.65,31.56,121,78.22Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M74.48,75.89s.5,10.83,21.67,8.5l3.5-5s-17.17,3.17-20.34-4.5Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.05,78.32l-22.9-3.93a101,101,0,0,0-19.25,42l34.75-4S112.46,93,123.05,78.32Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M105.9,75.14s-14.5,19.25-16,40.25l6.5-.75s3.79-26.72,16.52-38.23Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "86.98 84.56 83.48 88.22 85.48 92.89 89.15 89.22 86.98 84.56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.41,84S69,96.21,68.52,117.77L28.9,122.14Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M54.81,85.56S66,99.72,66,117.89l-2.83.33s-.5-19.5-10-30Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.81,77.72s-2,17.17,23.5,19l1.34-2.33S68.05,94.22,66,77.05Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M66.94,28.51S85.6,25.17,85.08,45.72a11.27,11.27,0,0,1-2.58,6.85s3.37,3.82,7.85,3.82c0,0,4.21-20.55-5-28.62S66.94,28.51,66.94,28.51Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M66.31,17.89l.63,10.62a12.16,12.16,0,0,1,3.79-1.79A18.28,18.28,0,0,1,84.23,31s-2.83-6.83-13.08-6.5C71.15,24.47,66.89,24.56,66.31,17.89Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "66.48 20.72 68.4 24.22 66.9 27.39 66.48 20.72"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M82.5,52.57a12.15,12.15,0,0,0,7.85,3.82s-5.87-3.33-5.87-7.08Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M39.81,89.89s-3.5-17.67,5.34-32.83l.75.58s-8.5,10.44-5.13,33.13Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 47.02,
    cy: 54.39,
    r: 2.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M108,79.73c.17-1.2.35-2.4.59-3.6-1.14.55-2.26,1.16-3.39,1.78q-.18,1.92-.27,3.81C105.93,81,107,80.37,108,79.73Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M101.37,84.28c0,1.28,0,2.55,0,3.82,1-.76,1.94-1.5,2.93-2.21.08-1.21.18-2.42.31-3.64C103.52,82.9,102.44,83.57,101.37,84.28Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M98.08,90.74c.07,1.28.16,2.55.28,3.81.9-.83,1.82-1.63,2.75-2.41q0-1.81.06-3.66C100.13,89.21,99.1,90,98.08,90.74Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M95.31,97.46c.17,1.28.38,2.54.62,3.78.82-.91,1.66-1.79,2.51-2.64-.11-1.2-.19-2.42-.24-3.65C97.22,95.76,96.26,96.59,95.31,97.46Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M93.19,104.46c.31,1.26.66,2.49,1.06,3.69.69-1,1.42-2,2.18-2.91-.25-1.17-.46-2.37-.63-3.58C94.91,102.55,94,103.48,93.19,104.46Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M92,111.73a37.23,37.23,0,0,0,1.63,3.49A35.73,35.73,0,0,1,95.29,112q-.63-1.68-1.11-3.45C93.41,109.58,92.67,110.63,92,111.73Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M102.58,79.6c0-1.35.07-2.72.21-4.09-1.43.32-2.86.74-4.28,1.2,0,1.49.12,3,.25,4.42C100,80.58,101.31,80.07,102.58,79.6Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M94.31,83.29q.27,2.22.66,4.38c1.21-.67,2.44-1.29,3.67-1.89-.11-1.35-.18-2.73-.22-4.11C97.05,82.16,95.68,82.71,94.31,83.29Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M90.79,90c.31,1.46.65,2.89,1,4.31,1.16-.77,2.33-1.49,3.51-2.18-.22-1.35-.41-2.71-.56-4.09C93.43,88.68,92.11,89.33,90.79,90Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M87.84,97c.43,1.43.88,2.83,1.37,4.21,1.1-.86,2.2-1.68,3.32-2.46-.33-1.32-.63-2.67-.9-4Q89.73,95.83,87.84,97Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M85.49,104.26c.53,1.39,1.11,2.75,1.72,4.08,1-1,2-1.86,3.09-2.73-.44-1.29-.85-2.61-1.23-3.94C87.87,102.49,86.67,103.35,85.49,104.26Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M83.75,111.67q1,2,2.08,3.91c.93-1,1.88-2,2.84-3q-.83-1.86-1.56-3.81C86,109.7,84.86,110.67,83.75,111.67Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M66.88,80a12.12,12.12,0,0,1-1.78-2.15,13.26,13.26,0,0,0-1.49,2.79,15.16,15.16,0,0,0,2.42,2A13.89,13.89,0,0,1,66.88,80Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M65.7,86.25a16.28,16.28,0,0,0,3,1.14,14,14,0,0,1-.06-2.81,13.94,13.94,0,0,1-2.4-1.45A16.39,16.39,0,0,0,65.7,86.25Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M69.36,90.75a17.71,17.71,0,0,0,3.14.19,16.19,16.19,0,0,1-.91-2.67,14.61,14.61,0,0,1-2.74-.63A17.23,17.23,0,0,0,69.36,90.75Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M74.1,94a21.11,21.11,0,0,0,3.07-.61A20.67,20.67,0,0,1,75.6,91a17.6,17.6,0,0,1-2.83.14A20.83,20.83,0,0,0,74.1,94Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M79.36,96a31.16,31.16,0,0,0,2.89-1.18,25.73,25.73,0,0,1-2-2,26.11,26.11,0,0,1-2.77.74A30.68,30.68,0,0,0,79.36,96Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M84.8,97c.93-.48,1.82-1,2.69-1.55-.79-.57-1.56-1.15-2.29-1.76-.85.42-1.73.8-2.64,1.17C83.27,95.56,84,96.29,84.8,97Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M58.94,86.32a27.62,27.62,0,0,0-3-1.18,25.94,25.94,0,0,1,.41,3.23c1,.33,2,.73,3,1.17C59.26,88.48,59.13,87.41,58.94,86.32Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M59.54,93.24c1,.48,1.92,1,2.87,1.58.05-1.07.06-2.14,0-3.24-.93-.58-1.86-1.12-2.8-1.62C59.65,91.07,59.62,92.16,59.54,93.24Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M62.06,98.38c.9.6,1.78,1.25,2.65,1.93.18-1,.32-2.12.43-3.2-.84-.7-1.7-1.35-2.57-2Q62.38,96.79,62.06,98.38Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M63.91,103.8c.82.71,1.61,1.46,2.39,2.25.31-1,.59-2.06.83-3.12-.75-.8-1.52-1.56-2.3-2.27C64.56,101.73,64.25,102.78,63.91,103.8Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M65.07,109.41c.72.81,1.41,1.65,2.08,2.53.44-1,.85-2,1.22-3-.65-.88-1.31-1.73-2-2.54C66,107.44,65.53,108.44,65.07,109.41Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M65.51,115.13c.61.89,1.2,1.81,1.76,2.77.55-.92,1.08-1.86,1.58-2.83-.54-.95-1.09-1.87-1.67-2.76C66.65,113.28,66.09,114.22,65.51,115.13Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M43.81,55.11a3.43,3.43,0,0,0-3.51-.39,23.11,23.11,0,0,0-2.74,1.43A4.63,4.63,0,0,0,43.81,55.11Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M50.48,55.56c-.53-.29,1.83-2.5,6.67-1.67C57.15,53.89,55.48,58.22,50.48,55.56Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M48.55,57.57c.11-.59,2.94,1,3.62,5.85C52.17,63.42,47.53,63.15,48.55,57.57Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M45,51.72a11.15,11.15,0,0,1,.33-7.16A10.88,10.88,0,0,1,47,51.06,5.18,5.18,0,0,0,45,51.72Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M48.31,51.39s2-4.5,5.5-4.67c0,0-.66,4.34-3.5,6.67C50.31,53.39,49.31,51.56,48.31,51.39Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.23,126,107,137.48l3.52,2.17a15.32,15.32,0,0,1,3.77,4.42c.34.68,2.32-.07.61-3l-1.39-2.84,6.45,5.31s3.54,3.21,3.69,1.73c.1-.94-1.29-2.86-1.88-3.26s-4.88-5.44-4.88-5.44l5.24,3.93s3.88,3.19,4.21,2.66c1.25-2-1.3-3.77-2-4.21s-5.79-5-5.79-5l6.88,3.87s2.63,1.89,2.82,1.16c.46-1.75-1.39-3-1.77-3.2-.69-.4-5.82-3.81-5.82-3.81l1.81.25s5.3,1.92,5.34,1.45c.19-2.29-9.33-6.27-9.33-6.27A22.21,22.21,0,0,0,116.23,126Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M84.24,171.27l-.09-15.34s-8.75-.25-10,4.75S84.24,171.27,84.24,171.27Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.4,
    y: 151.18,
    width: 7.5,
    height: 18.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M90,196.15s6.78,7.18,0,8.77c0,0,1.6,5.18-8.37,6.78s-48.25,8-45.06-59.42l27.51,3.19L74.85,178.6Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.24,157.27s12.23,12.16,11.83,25.32,7.18,27.91,21.54,19.14l.63-7.46,3-10-3-1.34.23-3.61-.8-1.6.6-1.59a12.11,12.11,0,0,1-1-1.4c-.24-.44,2-6.3-1.7-6.3-5.11,0-9.67.17-10.29-2.71-1-4.4-2.28-7,1-7.79,13.05-3,14.33-3,14.33-3s8.2-28.57-22.51-30.56-35.89,27.51-35.89,27.51Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.66,191.36a4.14,4.14,0,0,0-2.49,0c-1.89.61-4.1,1.94-5.6-.23l1.25.42a3.42,3.42,0,0,0,2.28-.84s-.22-1.94,1.35-1.86a1.19,1.19,0,0,1,1.19,1.56S87.36,190.17,87.66,191.36Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.89,196.37s-.15-1.42-.6-1.42-5.91,3.22-9.35-1c0,0,2.17,5,8.67,2.1A.86.86,0,0,1,87.89,196.37Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M34.5,154.53l10.13,1.89c4.93-8.4,14.66-20.61,28.52-18,14.74,2.79,18.25,11.93,19,17a8.92,8.92,0,0,0,3.33-1.17c7.62-8.13,32.95-43.57,32.95-43.57l-99.6,11.36V147.4C28.88,154,34.5,154.53,34.5,154.53Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M78.57,183.27a4.67,4.67,0,1,1,4.67,4.66A4.67,4.67,0,0,1,78.57,183.27Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.49,191.93s.33,1.5-2.09,1.75S86,193.6,86.49,191.93Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.27,176.13l-.6,1.59-2.35-.08A4.06,4.06,0,0,1,90.27,176.13Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M90.47,179.32a3.55,3.55,0,0,0-.54.24s-2.07-.8-2.61-1.92l2.35.08Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M89.15,205.18s-7.5,5.5-15.75,2-14.25-7.25-15-32.5c0,0,.14-13.94-11.18-19a24.88,24.88,0,0,1,8.93,18.47c.25,12-.25,30.5,17.25,35S90,204.92,90,204.92Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M91.24,214.93l-.69-10.18s-7.71,3.46-14.23,2.27a26,26,0,0,1-6.67-4.92s3.24,10.24,10.58,10S88.79,212.54,91.24,214.93Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M36.57,154.6s9.33,4.33,8,16.33,2.67,29.67,7.67,32C52.24,202.93,38.9,201.27,36.57,154.6Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M83.07,156.93s-.5-10.83-21.67-8.5l-3.5,5s17.17-3.16,20.34,4.5Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.5,154.5l22.9,3.93a101,101,0,0,0,19.25-42l-34.75,4S45.09,139.82,34.5,154.5Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M51.65,157.68s14.5-19.25,16-40.25l-6.5.75s-3.79,26.72-16.52,38.24Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "70.57 148.27 74.07 144.6 72.07 139.93 68.4 143.6 70.57 148.27"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.14,148.78S88.59,136.61,89,115.06l39.62-4.67Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M102.74,147.27S91.57,133.1,91.57,114.93l2.83-.33s.5,19.5,10,30Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.74,155.1s2-17.17-23.5-19l-1.34,2.33s20.6.18,22.63,17.34Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M90.61,204.32S72,207.65,72.47,187.1a11.29,11.29,0,0,1,2.58-6.85s-3.37-3.82-7.85-3.82c0,0-4.21,20.56,5,28.62S90.61,204.32,90.61,204.32Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M91.24,214.93l-.63-10.61a12.23,12.23,0,0,1-3.79,1.78,18.23,18.23,0,0,1-13.5-4.25s2.83,6.83,13.08,6.5C86.4,208.35,90.65,208.27,91.24,214.93Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "91.07 212.1 89.15 208.6 90.65 205.43 91.07 212.1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M75.05,180.25a12.19,12.19,0,0,0-7.85-3.82s5.87,3.34,5.87,7.09Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M117.74,142.93s3.5,17.67-5.34,32.84l-.75-.59s8.5-10.43,5.13-33.12Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 110.53,
    cy: 178.43,
    r: 2.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M49.56,153.09c-.17,1.2-.36,2.4-.59,3.6,1.14-.55,2.26-1.15,3.38-1.78.12-1.28.21-2.55.28-3.81C51.61,151.79,50.59,152.45,49.56,153.09Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M56.18,148.55c0-1.28,0-2.56,0-3.82-1,.76-1.93,1.49-2.92,2.2-.08,1.21-.19,2.43-.32,3.65C54,149.93,55.11,149.25,56.18,148.55Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M59.47,142.08c-.07-1.28-.16-2.55-.28-3.81-.91.83-1.82,1.64-2.75,2.41,0,1.21,0,2.44-.06,3.66C57.42,143.62,58.45,142.87,59.47,142.08Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M62.24,135.36c-.17-1.27-.38-2.54-.62-3.78-.82.92-1.66,1.8-2.51,2.65.11,1.2.19,2.41.24,3.64C60.33,137.07,61.29,136.23,62.24,135.36Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M64.36,128.36c-.31-1.25-.66-2.49-1.06-3.69-.7,1-1.43,2-2.18,2.91.25,1.18.45,2.37.63,3.59C62.64,130.27,63.51,129.34,64.36,128.36Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M65.58,121.09a37.28,37.28,0,0,0-1.64-3.49,35.85,35.85,0,0,1-1.68,3.2c.41,1.11.79,2.26,1.11,3.45C64.14,123.24,64.88,122.2,65.58,121.09Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M55,153.22c0,1.35-.08,2.72-.21,4.09,1.42-.31,2.86-.74,4.28-1.19,0-1.5-.12-3-.25-4.43C57.51,152.24,56.24,152.76,55,153.22Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M63.24,149.53c-.18-1.47-.4-2.93-.66-4.37-1.22.66-2.44,1.29-3.67,1.88.11,1.36.18,2.73.21,4.12C60.5,150.66,61.87,150.12,63.24,149.53Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M66.76,142.8c-.31-1.46-.65-2.9-1-4.31-1.16.76-2.33,1.49-3.51,2.18.22,1.34.41,2.71.56,4.09C64.12,144.14,65.44,143.49,66.76,142.8Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M69.71,135.79c-.43-1.43-.88-2.83-1.38-4.21-1.09.86-2.19,1.68-3.31,2.46.33,1.33.63,2.67.89,4C67.19,137.35,68.45,136.59,69.71,135.79Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M72.06,128.56c-.54-1.38-1.11-2.75-1.72-4.08-1,1-2,1.86-3.09,2.74.44,1.29.85,2.6,1.23,3.94C69.68,130.33,70.88,129.47,72.06,128.56Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M73.79,121.15c-.66-1.34-1.35-2.64-2.07-3.91-.93,1-1.88,2-2.84,3,.55,1.25,1.07,2.52,1.56,3.82C71.57,123.12,72.69,122.16,73.79,121.15Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M90.67,152.79a12.37,12.37,0,0,1,1.77,2.14,13,13,0,0,0,1.5-2.79,15.7,15.7,0,0,0-2.42-2A14,14,0,0,1,90.67,152.79Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M91.84,146.57a15.91,15.91,0,0,0-2.94-1.14,14,14,0,0,1,.06,2.81,14.74,14.74,0,0,1,2.4,1.45A15.53,15.53,0,0,0,91.84,146.57Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M88.19,142.07a17.82,17.82,0,0,0-3.14-.19,16.85,16.85,0,0,1,.91,2.67,15.44,15.44,0,0,1,2.74.63A17.52,17.52,0,0,0,88.19,142.07Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M83.45,138.86a24.17,24.17,0,0,0-3.07.61A23.12,23.12,0,0,1,82,141.84a20.17,20.17,0,0,1,2.83-.14A22,22,0,0,0,83.45,138.86Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M78.18,136.88c-1,.35-2,.74-2.88,1.17.71.66,1.39,1.35,2,2a24.29,24.29,0,0,1,2.76-.74A27.1,27.1,0,0,0,78.18,136.88Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M72.75,135.84c-.93.49-1.82,1-2.69,1.55.79.57,1.56,1.15,2.29,1.76.85-.42,1.73-.8,2.63-1.16C74.28,137.26,73.53,136.53,72.75,135.84Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M98.61,146.5a29,29,0,0,0,3,1.19,26.18,26.18,0,0,1-.41-3.23c-1-.34-2-.73-3-1.17Q98.33,144.88,98.61,146.5Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M98,139.59c-1-.48-1.92-1-2.86-1.58,0,1.06-.06,2.14,0,3.23.92.58,1.86,1.12,2.8,1.62C97.9,141.76,97.93,140.66,98,139.59Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M95.49,134.44c-.9-.6-1.78-1.24-2.65-1.93-.18,1.05-.33,2.12-.43,3.21.84.69,1.7,1.34,2.57,2Q95.18,136,95.49,134.44Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M93.63,129c-.81-.71-1.6-1.46-2.38-2.25-.31,1-.59,2.06-.83,3.13.75.79,1.52,1.55,2.3,2.27C93,131.09,93.29,130.05,93.63,129Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M92.48,123.41c-.72-.8-1.41-1.65-2.08-2.53-.44,1-.85,2-1.22,3,.65.88,1.31,1.73,2,2.54C91.58,125.39,92,124.38,92.48,123.41Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M92,117.7c-.62-.89-1.2-1.81-1.76-2.77-.55.91-1.08,1.85-1.58,2.82.53,1,1.09,1.88,1.67,2.77C90.9,119.55,91.46,118.6,92,117.7Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M113.74,177.71a3.4,3.4,0,0,0,3.51.39,23.11,23.11,0,0,0,2.74-1.43A4.64,4.64,0,0,0,113.74,177.71Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M107.07,177.27c.53.28-1.83,2.5-6.67,1.66C100.4,178.93,102.07,174.6,107.07,177.27Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M109,175.25c-.11.59-2.94-1-3.62-5.84C105.38,169.41,110,169.68,109,175.25Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M112.57,181.1a11.17,11.17,0,0,1-.33,7.17,10.88,10.88,0,0,1-1.67-6.5A5.12,5.12,0,0,0,112.57,181.1Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M109.24,181.43s-2,4.5-5.5,4.67c0,0,.66-4.33,3.5-6.67C107.24,179.43,108.24,181.27,109.24,181.43Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12D);
export default __webpack_public_path__ + "static/media/12_d.841ab5a2e14baa0591f01ef30e7afb63.svg";
export { ForwardRef as ReactComponent };